import { PictureProps } from '@v2/components/imageHandling/components/Picture';
import { isWeb } from '@helpers';

interface UseManagePictureParams extends Pick<PictureProps, 'triggerShowActions' | 'showActions'> {}

export const useManagePicture = ({ showActions, triggerShowActions }: UseManagePictureParams) => {
  const onImageZoomStart = () => {
    if (isWeb || !showActions) return;
    triggerShowActions?.();
  };

  return { onImageZoomStart };
};
